enum CalendarType {
    All = "all",
    Today = "today",
    Week = "week",
    MyEvents = "my events",
}

export default CalendarType;